import {GetSeferData}   from "SeferPetach/GetData";

export async function getChartData(obj) {
    var payload = await GetSeferData("rf6", obj);
    return (payload);
}
export async function getFilterMeta(){
    var payload = await GetSeferData("rfaux3", {});
    return (payload);
}